import { apm } from '@elastic/apm-rum';
import axios from 'axios';
class UserService {
    static auth;
    static config;
    static user;
    constructor(auth, options) {
        UserService.auth = auth;
        if (options) {
            UserService.config = options;
        }
    }
    headers() {
        return {
            Authorization: `Bearer ${UserService.auth.currentToken}`,
        };
    }
    async fetchCurrentUserProfile() {
        try {
            const res = await axios.get(UserService.config.API.baseApiUrl + '/profile', {
                headers: this.headers(),
            });
            UserService.user = res.data;
            if (apm.isActive()) {
                apm.setUserContext({
                    id: res.data.id,
                    email: res.data.email ?? undefined,
                });
            }
            return UserService.user;
        }
        catch (error) {
            console.error(error);
            throw error;
        }
    }
    /**
     * Return the current user profile based on local storage.
     * @returns The Profile.ProfileTransport object of the current user.
     */
    get() {
        return UserService.user;
    }
}
export default UserService;
//# sourceMappingURL=User.service.js.map